import React from "react";

interface CardNavigationButtonsProps {
    onBack?: () => void;
    onNext: () => void;
    isLoading?: boolean;
    nextButtonText?: string;
    disabled?: boolean;
    className?: string;
    hideBack?: boolean;
}

const CardNavigationButtons = ({
    onBack,
    onNext,
    isLoading = false,
    nextButtonText = "Next",
    disabled = false,
    className,
    hideBack = false,
}: CardNavigationButtonsProps) => {
    const showBack = !!onBack && !hideBack;

    const handleBackClick = () => {
        if (onBack) {
            onBack();
        }
    };

    const handleNextClick = () => {
        onNext();
    };
    return (
        <div className={`w-[370px] tablet:w-[448px] flex ${showBack ? "justify-between" : "justify-end"} pt-3 ${className}`}>
            {showBack && (
                <button
                    type="button"
                    onClick={handleBackClick}
                    className="w-[120px] h-[36px] rounded bg-base-200 text-sm font-semibold text-gray-800 hover:bg-gray-300 transition-colors"
                >
                    Back
                </button>
            )}

            <button
                type="button"
                onClick={handleNextClick}
                disabled={isLoading || disabled}
                className={`w-[120px] h-[36px] rounded text-sm font-semibold transition-colors focus:outline-none ${
                    isLoading || disabled
                        ? "bg-gray-400 text-gray-600 cursor-not-allowed"
                        : "bg-secondary-content text-white hover:bg-blue-800"
                }`}
            >
                {isLoading ? "Loading..." : nextButtonText}
            </button>
        </div>
    );
};

export default CardNavigationButtons;
